
import { AuthService } from './auth-service'

const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN;
const axios = require('axios').default;

export class LiveService {

    // PUT: The PUT method replaces all current representations of the target resource with the request payload.
    // PATCH: The PATCH method is used to apply partial modifications to a resource.

    static async getList(params) {
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/liveview/`
            const response = await axios.get(base_url, {params: params});
            // console.log(response);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    static async getDetail(id) {
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/liveview/`
            const response = await axios.get(`${base_url}${id}`,);
            // console.log(response);
            return response.data;
        } catch (error) {
            return error.response;
        }
    }

    static async update(id, data) {
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/liveview/`
            const response = await axios.put(
                `${base_url}${id}/`,
                data,
                {
                    headers: {
                        //'Content-Type': 'multipart/form-data',
                        'Authorization': `Token ${AuthService.getWpProxyToken()}`
                    }
                }
            );
            //console.log(response);
            return response;
        } catch (error) {
            console.error(error.response.data);
            return error.response;
        }
    }

    static async delete(id) {
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/liveview/`
            const response = await axios.patch(
                `${base_url}${id}/`,
                {is_hidden: true},
                {
                    headers: {'Authorization': `Token ${AuthService.getWpProxyToken()}`}
                }
            );
            console.log(response);
            return response;
        } catch (error) {
            console.error(error.response.data);
            return error.response;
        }
    }

    static async getListTag(params) {
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/livetag/`
            const response = await axios.get(base_url, {params: params});
            //console.log('getListTag: ', response);
            return response.data;
        } catch (error) {
            return error.response;
        }
    }

    static async getTag(id) {
        //let params = '?name__icontains=3';
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/livetag/`
            const response = await axios.get(`${base_url}${id}`,);
            //console.log('getTag: ', response);
            return response.data;
        } catch (error) {
            return error.response;
        }
    }

    static async addTag(data) {
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/livetag/`
            const response = await axios.post(
                `${base_url}`,
                data,
                {
                    headers: {
                        'Authorization': `Token ${AuthService.getWpProxyToken()}`
                    }
                }
            );
            //console.log(response);
            return response;
        } catch (error) {
            console.error(error.response.data);
            return error.response;
        }
    }

    static async updateTag(id, data) {
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/livetag/`
            const response = await axios.put(
                `${base_url}${id}/`,
                data,
                {
                    headers: {
                        'Authorization': `Token ${AuthService.getWpProxyToken()}`
                    }
                }
            );
            //console.log(response);
            return response;
        } catch (error) {
            console.error(error.response.data);
            return error.response;
        }
    }

    static async deleteTag(_id) {
        try {
            const base_url = `${REACT_APP_DOMAIN}/api/livetag/`
            const response = await axios.delete(
                `${base_url}${_id}/`,
                {
                    headers: {'Authorization': `Token ${AuthService.getWpProxyToken()}`}
                }
            );
            //console.log(response);
            return response;
        } catch (error) {
            console.error(error.response.data);
            return error.response;
        }
    }

}